import { render } from "./FlowToggle.vue?vue&type=template&id=034b633d&scoped=true"
import script from "./FlowToggle.vue?vue&type=script&lang=js"
export * from "./FlowToggle.vue?vue&type=script&lang=js"

import "./FlowToggle.vue?vue&type=style&index=0&id=034b633d&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034b633d"]])

export default __exports__